import {IValidateBase} from "./IValidateBase";
import {AP_Validation_Email} from "./AP_Validation_Email";
// import {AP_Validation_Grid} from "./AP_Validation_Grid";
// import {AP_Validation_IpAddress} from "./AP_Validation_IpAddress";
// import {AP_Validation_MaxDate} from "./AP_Validation_MaxDate";
// import {AP_Validation_MaxLength} from "./AP_Validation_MaxLength";
// import {AP_Validation_MaxValue} from "./AP_Validation_MaxValue";
// import {AP_Validation_MinDate} from "./AP_Validation_MinDate";
// import {AP_Validation_MinLength} from "./AP_Validation_MinLength";
// import {AP_Validation_MinValue} from "./AP_Validation_MinValue";
// import {AP_Validation_Number} from "./AP_Validation_Number";
// import {AP_Validation_Recurrence} from "./AP_Validation_Recurrence";
import {AP_Validation_Required} from "./AP_Validation_Required";
import {AP_Validation_Url} from "./AP_Validation_Url";

export class ValidationManager {
    dicValidation: { [name: string]: IValidateBase } = {};
    lstValidations: any = [];
    // lstValidations: Array<IValidateBase> = [];
    //
    constructor(){

         //this.dicValidation["AP_Validation_Email"] = new AP_Validation_Email();
        // this.dicValidation["AP_Validation_Grid"] = new AP_Validation_Grid();
        // this.dicValidation["AP_Validation_IpAddress"] = new AP_Validation_IpAddress();
        // this.dicValidation["AP_Validation_MaxDate"] = new AP_Validation_MaxDate();
        // this.dicValidation["AP_Validation_MaxLength"] = new AP_Validation_MaxLength();
        // this.dicValidation["AP_Validation_MaxValue"] = new AP_Validation_MaxValue();
        // this.dicValidation["AP_Validation_MinDate"] = new AP_Validation_MinDate();
        // this.dicValidation["AP_Validation_MinLength"] = new AP_Validation_MinLength();
        // this.dicValidation["AP_Validation_MinValue"] = new AP_Validation_MinValue();
        // this.dicValidation["AP_Validation_Number"] = new AP_Validation_Number();
        // this.dicValidation["AP_Validation_Recurrence"] = new AP_Validation_Recurrence();
        //this.dicValidation["AP_Validation_Required"] = new AP_Validation_Required({});

        this.dicValidation['AP_Validation_Required'] = new AP_Validation_Required({});
        this.dicValidation['AP_Validation_Email'] = new AP_Validation_Email({});
        this.dicValidation['AP_Validation_Url'] = new AP_Validation_Url({});

        this.lstValidations = [];
        for (const currValidationKey in this.dicValidation) {
            this.lstValidations.push(this.dicValidation[currValidationKey]);
        }
        //this.lstValidations
        //

    }

    validate(prmValidationTypeCode:string, prmValue:any, prmValidationParams?:any) {
        let outObj:any = {}

        const currValidationInstance:any = this.dicValidation[prmValidationTypeCode];

        if (!!currValidationInstance
                    && currValidationInstance?.hasOwnProperty("ValidateValue")) {
            outObj = currValidationInstance?.ValidateValue(prmValue, prmValidationParams)
        }

        return outObj
    }
    //
    // Validate(prmQueryname?: string) {
    //     let currPageStruct = store.getState().store_PageStructure
    //
    //     let lstValidateElements = currPageStruct.lstElements.filter((prmElement: any) => {
    //         return !!prmElement.DataBindStr
    //             && (!prmQueryname || prmElement.DataBindStr.startswith(prmQueryname));
    //     });
    //
    //     if (lstValidateElements.length > 0 && this.dicValidation){
    //         for (let ind01 = 0; ind01 < lstValidateElements.length; ind01++) {
    //             const currElementObj = lstValidateElements[ind01];
    //
    //             // const currValidationInstance = this.dicValidation[currValidationObj.validateCode];
    //             //
    //             // if (currValidationInstance){
    //             //     currValidationInstance.Validate(prmElementObj)
    //             // }
    //         }
    //     }
    //     // alert("inside ValidationManager")
    // }
}
